"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryTable = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const entity_ui_1 = require("@sierralabs/entity-ui");
const query_core_1 = require("@sierralabs/query-core");
const useQuerySelectValue_1 = require("./hooks/useQuerySelectValue");
const useRunQuery_1 = require("./hooks/useRunQuery");
const default_1 = require("./plugins/default");
const htmlRegExp = /(<([^>]+)>)/i; // match
const htmlRegExpG = /(<([^>]+)>)/gi; // replace all
const SeeMoreDialog = props => {
    const { title, value } = props;
    const [open, setOpen] = (0, react_1.useState)(false);
    const text = (0, react_1.useMemo)(() => value.replace(htmlRegExpG, ''), [value]);
    const maxLength = 32;
    const seeMore = text.length > maxLength;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !seeMore ? text : react_1.default.createElement(react_1.default.Fragment, null,
            text.slice(0, maxLength).trim(),
            "..."),
        react_1.default.createElement(core_1.Link, { tabIndex: 0, style: { cursor: 'pointer', marginLeft: 4 }, onClick: () => setOpen(true) }, seeMore ? 'See more' : 'View formatted'),
        react_1.default.createElement(core_1.Dialog, { fullWidth: true, open: open, maxWidth: 'sm', onClose: () => setOpen(false), "aria-labelledby": 'alert-dialog-title', "aria-describedby": 'alert-dialog-description' },
            react_1.default.createElement(core_1.DialogTitle, null, title),
            react_1.default.createElement(core_1.DialogContent, null,
                react_1.default.createElement("div", { className: 'content', dangerouslySetInnerHTML: { __html: value } })),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(core_1.Button, { onClick: () => setOpen(false) }, "Close")))));
};
const StyledTableContainer = (0, styled_components_1.default)(core_1.TableContainer) `
  table {
    white-space: nowrap;
  }
`;
const QueryTable = props => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { select, query, onSelect } = props;
    const paramsState = (0, react_1.useState)(props.params || {});
    const [error, setError] = (0, react_1.useState)();
    const [selectedRows, setSelectedRows] = (0, react_1.useState)([]);
    const { entities } = (0, entity_ui_1.useEntityContext)();
    const { queryData, isRunningQuery, runQueryError, runPaginatedQuery } = (0, useRunQuery_1.useRunQuery)();
    const params = (_a = props.params) !== null && _a !== void 0 ? _a : paramsState[0];
    const setParams = (_b = props.onChange) !== null && _b !== void 0 ? _b : paramsState[1];
    // override default plugins
    const plugins = (0, react_1.useMemo)(() => {
        return props.plugins || default_1.defaultQueryBuilderPlugins;
    }, [props.plugins]);
    const queryManager = (0, react_1.useMemo)(() => {
        return new query_core_1.QueryManager(query, entities || [], plugins);
    }, [entities, plugins, query]);
    const selects = ((_d = (_c = queryManager.query) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.selects) || [];
    const colSpan = selects.length + +!!select;
    const renderValue = (column, value) => {
        var _a;
        // try to parse status
        return ((_a = column.selection) === null || _a === void 0 ? void 0 : _a.includes('.status')) &&
            typeof value === 'string' &&
            value.includes('/')
            ? value.slice(value.lastIndexOf('/') + 1)
            : value;
    };
    (0, react_1.useEffect)(() => {
        if (!query.config) {
            return;
        }
        const config = Object.assign({}, query.config);
        const limit = Math.min(100, params.limit || 0);
        const offset = (params.page || 0) * limit;
        config.limit = limit;
        config.offset = offset;
        if (params.order) {
            config.orderBys = [
                { propertyPath: params.order, order: params.direction || 'ASC' }
            ];
        }
        runPaginatedQuery(config);
    }, [
        params.direction,
        params.limit,
        params.order,
        params.page,
        query,
        query.config,
        runPaginatedQuery
    ]);
    // clear out selectedRows if queryData refreshes to prevent stale data selection
    (0, react_1.useEffect)(() => {
        queryData && setSelectedRows([]);
    }, [queryData]);
    (0, react_1.useEffect)(() => {
        setError(runQueryError);
    }, [runQueryError]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledTableContainer, null,
            react_1.default.createElement(core_1.Table, { stickyHeader: true },
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        select && react_1.default.createElement(core_1.TableCell, { padding: 'none' }), (_f = (_e = query.config) === null || _e === void 0 ? void 0 : _e.selects) === null || _f === void 0 ? void 0 :
                        _f.map((select, index) => {
                            var _a;
                            const columnMap = queryManager.queryAliasColumnMap.find(cm => cm.path === select.selection);
                            return (react_1.default.createElement(core_1.TableCell, { key: `${select.selection}-${index}` },
                                react_1.default.createElement(core_1.TableSortLabel, { active: params.order === select.selection, direction: params.order === select.selection &&
                                        params.direction === 'DESC'
                                        ? 'desc'
                                        : 'asc', onClick: () => {
                                        setParams(Object.assign(Object.assign({}, params), { order: select.selection, direction: params.direction === 'ASC' ? 'DESC' : 'ASC' }));
                                    } }, ((_a = columnMap === null || columnMap === void 0 ? void 0 : columnMap.column) === null || _a === void 0 ? void 0 : _a.displayName) || select.selection)));
                        }))),
                react_1.default.createElement(core_1.TableBody, null,
                    isRunningQuery && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: colSpan, padding: 'none' },
                            react_1.default.createElement(core_1.LinearProgress, null)))), (_g = queryData === null || queryData === void 0 ? void 0 : queryData.data) === null || _g === void 0 ? void 0 :
                    _g.map((item, index) => (react_1.default.createElement(core_1.TableRow, { key: index },
                        select && (react_1.default.createElement(core_1.TableCell, { padding: 'checkbox' },
                            react_1.default.createElement(core_1.Checkbox, { checked: selectedRows.includes(item), onClick: event => {
                                    event.stopPropagation();
                                    const copy = Array.from(selectedRows);
                                    const index = copy.indexOf(item);
                                    if (index > -1) {
                                        copy.splice(index, 1);
                                    }
                                    else {
                                        copy.push(item);
                                    }
                                    setSelectedRows(copy);
                                    onSelect === null || onSelect === void 0 ? void 0 : onSelect(copy);
                                } }))),
                        selects.map((select, index) => {
                            var _a, _b, _c, _d, _e, _f;
                            const plugin = select.pluginType
                                ? plugins.find(p => p.type === select.pluginType)
                                : undefined;
                            const pluginConfig = plugin
                                ? (_c = (_b = (_a = queryManager.query) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.pluginConfigs) === null || _c === void 0 ? void 0 : _c.find(p => p.type === plugin.type)
                                : undefined;
                            const pluginColumn = (_d = plugin === null || plugin === void 0 ? void 0 : plugin.columns) === null || _d === void 0 ? void 0 : _d.find(c => c.selection === select.selection);
                            const value = (0, useQuerySelectValue_1.getQuerySelectValue)({
                                item,
                                select,
                                expressionMap: (_e = queryManager.query) === null || _e === void 0 ? void 0 : _e.config
                            });
                            const columnMap = queryManager.queryAliasColumnMap.find(cm => cm.path === select.selection);
                            const title = ((_f = columnMap === null || columnMap === void 0 ? void 0 : columnMap.column) === null || _f === void 0 ? void 0 : _f.displayName) || select.selection;
                            return (react_1.default.createElement(core_1.TableCell, { key: index }, (pluginColumn === null || pluginColumn === void 0 ? void 0 : pluginColumn.component) ? (react_1.default.createElement(pluginColumn.component, { value: value, row: item, pluginConfig: pluginConfig, queryManager: queryManager })) : htmlRegExp.test(value) ? (react_1.default.createElement(SeeMoreDialog, { title: title, value: value })) : (renderValue(select, value))));
                        })))))),
            react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: !!error, onClose: () => setError(undefined) }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.')),
        react_1.default.createElement(core_1.TablePagination, { rowsPerPageOptions: [10, 25, 100], component: 'div', count: (queryData === null || queryData === void 0 ? void 0 : queryData.total) || 0, rowsPerPage: (_h = params.limit) !== null && _h !== void 0 ? _h : 100, page: (_j = params.page) !== null && _j !== void 0 ? _j : 0, onPageChange: (_, page) => setParams(Object.assign(Object.assign({}, params), { page })), onRowsPerPageChange: event => {
                setParams(Object.assign(Object.assign({}, params), { page: 0, limit: +event.target.value }));
            } })));
};
exports.QueryTable = QueryTable;
exports.default = exports.QueryTable;
//# sourceMappingURL=QueryTable.js.map